/**
 * Utility for handling external links in iOS standalone mode (home screen app).
 *
 * In iOS standalone mode, target="_blank" links open within the same WebView,
 * trapping users with no way to return. This utility detects standalone mode
 * and navigates properly to open links in Safari instead.
 */

export function isIOSStandalone(): boolean {
  return (
    ('standalone' in window.navigator && (window.navigator as any).standalone === true) ||
    window.matchMedia('(display-mode: standalone)').matches
  );
}

export function openExternalLink(url: string): void {
  if (isIOSStandalone()) {
    // In iOS standalone mode, navigate to the URL which opens in Safari
    // User can return to app via app switcher or home screen icon
    window.location.href = url;
  } else {
    // In normal browser mode, open in new tab
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
